var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "customer-select",
      attrs: {
        "data-bs-toggle": "tooltip",
        "data-bs-placement": "top",
        title: "Customers list",
        "data-ai-agent-type": "multi-select",
        "data-ai-agent-id": "customer-multi-select",
        "data-ai-agent-label": "Customer",
      },
    },
    [
      _c(
        "select",
        {
          ref: "ms",
          staticClass: "form-control",
          staticStyle: { width: "100%" },
          attrs: {
            "data-ai-agent-type": "multi-select",
            "data-ai-agent-id": "customer-multi-select-native",
            "data-ai-agent-label": "Customer Native Select",
          },
        },
        [
          _c("option", { attrs: { value: "0" } }, [
            _vm._v("\n      All customers\n    "),
          ]),
          _vm._v(" "),
          _vm._l(_vm.customers, function (c) {
            return _c("option", { key: c.id, domProps: { value: c.id } }, [
              _vm._v("\n      " + _vm._s(c.name) + "\n    "),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }